const en = {
    bankDetails: {
        title: 'Bank details',
        submit: 'Submit bank details',
        pageTitle: 'Add your details',
        pageDescription:
            'Add your mobile number and bank details to set up your loan.',
        bankDetails: {
            label: 'Bank details',
            description:
                'Use your UK personal current account (sole or joint) for funding and Direct Debit repayments.',
        },
        accountHolderName: {
            label: "Account holder's name",
            required: 'Enter the name as it appears on the account',
        },
        accountNumber: {
            label: 'Account number',
            placeholder: '00000000',
            validationError: 'Enter a valid 8-digit account number',
        },
        sortCode: {
            label: 'Sort code',
            placeholder: '00-00-00',
            validationError: 'Enter a valid 6-digit sort code',
        },
        phoneNumber: {
            label: 'Mobile number',
            usageDescription: "We'll use this for security checks.",
            validationError: 'Enter a valid UK mobile number',
        },
        confirmation: {
            text: 'I confirm this is my UK personal current account (not a business or savings account) and that I’m authorised to set up Direct Debits on it.',
            validationError:
                'You must confirm this is a UK personal current account',
        },
        validation: {
            required: 'This is a required field',
        },
        security: {
            message: 'Your details are encrypted and stored securely.',
        },
        bankLogoAlt: 'Bank logo',
        submitButton: 'Submit details',
        privacy: {
            title: 'How we use your personal information',
            description1: 'We use your personal data in line with our ',
            description2:
                ' which has important information about how third parties may use it and the potential consequences.',
            privacyPolicy: 'Privacy Policy',
        },
    },
    docs: {
        illustrationAlt: 'Documents illustration',
        pageTitle: 'You’re almost done',
        pageDescription:
            'Review and accept your loan documents before submitting your application',
        submitButton: 'Continue to loan documents',
    },
    docsList: {
        illustrationAlt: 'Documents List illustration',
        pageTitle: 'Your loan documents',
        pageDescription:
            'Open, review, and accept each document to complete your application.',
        directDebitAgreement: {
            title: 'Direct Debit agreement',
            description: 'Sets up monthly Direct Debit repayments.',
        },
        preContractCreditInformation: {
            title: 'Pre-contract credit information',
            description: 'A summary of your key loan information.',
        },
        adequateExplanation: {
            title: 'Adequate explanations',
            description: 'An explanation of your loan information.',
        },
        loanAgreement: {
            title: 'Loan agreement',
            description: 'The full legal terms of your loan.',
            reviewButton: 'Review & sign',
            acceptedBadge: 'Signed & accepted',
        },
        reviewButton: 'Review & accept',
        acceptedBadge: 'Accepted',
        infoPanelMessage:
            'You can download these documents as you review them, but we’ll also email them to you once you’ve completed your application.',
        button: 'Continue',
    },
    docModal: {
        button: 'Accept & continue',
        signButton: 'Sign loan agreement',
        signingButton: 'Signing',
        signedButton: 'Signed',
        directDebitAgreement: 'Selina Finance Direct Debit Agreement',
        pcci: 'Selina Finance PCCI',
        adequateExplanation: 'Selina Finance Adequate Explanations',
        loanAgreement: 'Selina Finance Loan Agreement',
    },
    expired: {
        illustrationAlt: 'Hourglass illustration',
        title: 'This application is no longer active',
        description:
            'For security reasons, applications only stay active for 24 hours. You can start again by returning to the comparison site where you saw your offer.',
        returnButton: 'Start again',
    },
    concurrentApplications: {
        illustrationAlt: 'Selina logo illustration',
        title: 'You already have an active application',
        description:
            'It looks like you started an application with us within the last 24 hours.',
        pickUpWhereYouLeftOff: 'To pick up where you left off, you can:',
        checkBrowserTabs: 'Check your open browser tabs',
        searchBrowserHistory: 'Search your browser history for "Selina"',
        beginNewApplication:
            "If you'd rather begin a new application, you'll be able to do this through the comparison site 24 hours after starting your original one.",
        continueActiveApplication:
            'Click here to continue with your active application.',
    },
    notFoundPage: {
        error: '404 error',
        title: 'Sorry, this page could not be found',
        description:
            'Try going back to return to where you left off, or go to the start of the application to begin again.',
        returnButton: 'Return to start',
    },
    existingLoanPage: {
        title: 'You already have a loan with us',
        description:
            "You can only have one loan with Selina at a time. It looks like you already have an active loan, so you won't be able to apply for another right now.",
        loginButton: 'Log in to your account',
    },
    errorContainer: {
        highlightedError:
            'Please fix the {{count}} highlighted error to submit your details.',
        highlightedErrorMultiple:
            'Please fix the {{count}} highlighted errors to submit your details.',
        bankDetailsReattemptError: {
            title: 'You have one attempt remaining',
            description:
                "We couldn't verify your bank account details. Please double check them and try again.",
        },
        genericError: {
            title: 'Please try again',
            description:
                "Sorry, that didn't work as expected. Don't worry, nothing's been lost.",
        },
    },
    progress: {
        complete: '{{progress}}% complete',
        addDetails: 'Add your details',
        verifyIdentity: 'Verify identity',
        reviewDocs: 'Review loan docs',
        getFunded: 'Submit & get funded',
        restartWarning:
            'If you close this tab, you may lose your current application',
    },
    submit: {
        illustrationAlt: 'Submit illustration',
        title: 'You’re ready to submit',
        description:
            'Take a moment to check your loan details and the account we’ll pay your funds into, then submit your application.',
        descriptionSecondary:
            'If you want to change anything, you’ll need to start again.',
        amountLabel: 'Amount',
        monthlyRepaymentsLabel: 'Monthly repayments',
        termLabel: 'Term',
        termYear: '{{count}} year',
        termYears: '{{count}} years',
        termMonths: '{{count}} months',
        rateLabel: 'Rate',
        totalRepayableLabel: 'Total repayable',
        personalisedExample:
            'Personalised example: A {{amount}} loan over {{term}} results in {{monthlyPaymentsCount}} monthly payments of {{monthlyPayment}} at a fixed annual rate of {{fixedRate}}%. The total amount repayable is {{totalRepayable}}, including {{totalInterest}} in interest. APR {{apr}}%.',
        fundsTitle: 'Where we’ll send your funds',
        accountLinePrefix: 'Account number',
        creditCheckWarning:
            'When you submit, we’ll run a hard credit check. This may affect your credit score.',
        submitButton: 'Submit & get funds',
    },
    verify: {
        title: 'Let’s verify your identity',
        description:
            'Continue to Veriff for a quick check that keeps your application safe and secure',
        checklist: {
            document:
                'Have your UK passport, driving license or national ID card ready',
            camera: 'Photograph your original physical ID — we can’t use screenshots or document copies',
            lighting: 'Make sure you’re in a well-lit room',
        },
        callout: 'You’ll be automatically returned to Selina when you’re done',
        continueButton: 'Continue to Veriff',
    },
    verifyResubmission: {
        title: 'We couldn’t verify your identity this time',
        intro: 'Please try again and make sure:',
        bullets: [
            'You use a valid UK passport, driving licence or national ID card',
            'Your document is in date and undamaged',
            'You take clear photos in good lighting, with all details visible',
        ],
        tryAgainButton: 'Try again',
    },
    footer: {
        companyReg:
            'Selina Finance Limited is a company registered in England and Wales (11497606)',
        fcaDetails:
            'Selina Finance Limited is authorised and regulated by the Financial Conduct Authority (FRN 820183). Our registered address is HYLO 103-105 Bunhill Row, London EC1Y 8LZ',
    },
    help: {
        title: 'Need help?',
        phone: '020 3745 7695 (Mon - Fri, 9am - 5pm)',
    },
    trustbar: {
        message: 'Complete your application in minutes',
    },
    declinedPage: {
        heading: "Unfortunately, we can't offer you a loan right now",
        body1: "Based on the information you've provided, we're not able to offer you a loan at the moment. This won’t impact your credit score.",
        body2: 'You can apply again in the future if your circumstances change.',
        body3Prefix:
            "If you'd like to request a review or dispute this decision, please see our ",
        body3Suffix: ' for details and how to contact us.',
        returnButton: 'Return to the comparison site',
    },
    approvedPage: {
        illustrationAlt: 'Flying money illustration',
        badge: 'Loan approved',
        title: 'Your money is on the way',
        body1: 'We aim to send your money within 48 hours, Monday to Friday, excluding bank holidays.',
        body2: "We'll email you now with your loan details and documents, and again when your funds reach your account.",
        manageTitle: 'Manage your loan in the Selina app',
        features: {
            balance: 'Easily track your balance',
            documents: 'View your loan documents',
            extraPayments: 'Check your next payment',
        },
        googlePlayAlt: 'Get it on Google Play',
        appStoreAlt: 'Download on the App Store',
        mobileMockupAlt: 'Selina app mobile mockup',
    },
    appDownload: {
        title: 'Redirecting to app store...',
        description:
            'If you are not redirected automatically, use the link below.',
        continue: 'Continue',
    },
};

export default en;
